/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$("a.readmorecol").click(function(){
$(this).parents(".twelve.columns ").find(".section.clearfix.collection_description").addClass("show");
  $(this).hide();
  $("a.readlesscol").show();
})
$("a.readlesscol").click(function(){
$(this).parents(".twelve.columns ").find(".section.clearfix.collection_description").removeClass("show");
  $(this).hide();
  $("a.readmorecol").show();
})

$("a.readmorecol").click(function(){
$(this).parents(".collection__description").find(".collection_description").addClass("show");
  $(this).hide();
  $("a.readlesscol").show();
})
$("a.readlesscol").click(function(){
$(this).parents(".collection__description").find(".collection_description").removeClass("show");
  $(this).hide();
  $("a.readmorecol").show();
})

// $(document).ready(function(){
//   var v2 = []; 
//   setTimeout(function(){ 
//    var v1 =  $(".mw-option-select  select option:nth-child(2)").data("value-id");
//     	 var a = $(".divinfo input[type=text]").val();
     	 
//           if( a == "" )
//             {
               
//               $(".mw-option-select  select option:nth-child(2)").removeAttr("data-value-id");
              
//             }
//     		else if( a != "" )
//             {
//               $(".mw-option-select  select option:nth-child(2)").attr("data-value-id",v1);
//               //console.log(v1);
//             }
//     //console.log(v1);
//     v2.push(v1);
   
//   }, 2000);
  
//    $(".divinfo input[type=text]").on("change",function(){
//   	$(".mw-option-select  select option:nth-child(2)").attr("data-value-id",v2);
    
//    console.log(v2);
//   });
  
  
// });

$(document).ready(function(){
	 $('body').on('click', 'button[data-action="decrease-quantity"]', function(e){
       e.preventDefault();
    var getline = parseInt($(this).siblings('input').attr("data-line"));
    var getval = parseInt($(this).siblings('input').val());
       
    getval = getval - 1;
    $(this).siblings('input').val(getval);
   // $(this).addClass("disablethis");
   // $(this).siblings("div").addClass("disablethis");
     if( getval == 1 )
      {
        $(this).addClass("disablethis-1");
      }
  //  update_quantity(getval,getline);
   var dat = $(this).parents(".mini-cart__line-item.mw_cart_line").find("span").data("mw-relation");
    var dat1 = $(this).parents(".mini-cart__line-item.mw_cart_line").next(".mini-cart__line-item.mw_cart_line").find("span").data("mw-relation");
    console.log(dat1);
    if( dat == "" )
    {
      updateQty($(this),getval,getline);
       setTimeout(function(){ 
    		window.location.reload();
		  }, 3000);
    }
       else if ( dat != "" && dat1 == "undefined" )
       {
         
       	 updateQty($(this),getval,getline);
         setTimeout(function(){ 
              window.location.reload();
            }, 3000);
       }
    else
    {
     update_quantity1($(this),getval,getline);
//        setTimeout(function(){ 
//     		window.location.reload();
// 		  }, 3000);
    }
       
  })
  $('body').on('click', 'button[data-action="increase-quantity"]', function(e){
    e.preventDefault();
    var getline = parseInt( $(this).siblings('input').attr("data-line"));
    var getval = parseInt($(this).siblings('input').val());
  
    getval = getval + 1;
    $(this).siblings('input').val(getval);
  //  $(this).addClass("disablethis");
  //  $(this).siblings("div").addClass("disablethis");
 //   $(this).siblings(".minus-qty.qty-settings").removeClass("disablethis-1");
  //  update_quantity(getval,getline);
    var dat = $(this).parents(".mini-cart__line-item.mw_cart_line").find("span").data("mw-relation");
    var dat1 = $(this).parents(".mini-cart__line-item.mw_cart_line").next(".mini-cart__line-item.mw_cart_line").find("span").data("mw-relation");
        console.log(dat1);
    if( dat == "" )
    {
      updateQty($(this),getval,getline);
      setTimeout(function(){ 
    		window.location.reload();
		  }, 3000);
    }
  
    else
    {
      update_quantity($(this),getval,getline);
      setTimeout(function(){ 
    		window.location.reload();
		  }, 3000);
    }
    
    
    
  })
  $(".question--mark--label").click(function(){
    $(".question--mark--content").toggle();
  })
})
function updateQty(el,getval,getline) {

    var itemId = $(el).attr("itemid");
    var qty = getval;
  
  $.post('/cart/update.js', 'updates['+itemId+']='+qty);
  
 //  setTimeout(function(){ 
 //    window.location.reload();
 //  }, 500);
}


function update_quantity(el,getval,getline)
{
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=' + getval + '&line=' + getline,
    dataType: 'json',
    success: function(data) 
    {
      el.parents(".cart_item").next("li").find(".plus-qty.qty-settings").trigger("click");
     
      		
             /* el.parents(".cart_item").next("li").find(".plus-qty.qty-settings").on('click', function(e){
                  e.preventDefault();
                  var getline = parseInt( $(this).siblings('input').attr("data-line-item-index"));
                  var getval = parseInt($(this).siblings('input').val());

                  getval = getval + 1;
                  $(this).siblings('input').val(getval);


               updateQty1($(this).parents(".cart_item").next("li"),getval,getline);
              });*/
      
    }
  })
}
function update_quantity1(el,getval,getline)
{
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=' + getval + '&line=' + getline,
    dataType: 'json',
    success: function(data) 
    {
      if(getval == 0){
        var getqty = el.parents(".cart_item").next("li").find(".changequantity").attr("data-line-item-index");
        getqty = parseInt(getqty) - 1 ;
        el.parents(".cart_item").next("li").find(".changequantity").attr("data-line-item-index",getqty);
      }
      el.parents(".cart_item").next("li").find(".minus-qty.qty-settings").trigger("click");
     console.log(getval);
      console.log(getline);
      setTimeout(function(){ 
     		window.location.reload();
 		  }, 3000);
      
    }
  })
}

$(".img_trigger").on("click",function(){
 $(this).hide();
  $(this).siblings(".chat-option.desktop-only").show();
});
$(".chat-option.desktop-only").on("click",function(){
 $(this).hide();
  $(this).siblings(".img_trigger").show();
});

$(".offer-act button").on("click",function(e){
  e.preventDefault();
  $(this).siblings(".offer-price").toggleClass("show");
});

$(".offer-price input").on("keyup",function(){
 var val = $(this).val();
 if(val != '')
 {
   var href = $(this).siblings("a").attr("data-url");
   var offer = href +" Offer Price:-"+ val;
   $(this).siblings("a").attr("href",offer).removeClass("disabled");
 }
 else
 {
   var href = $(this).siblings("a").attr("data-url");
   $(this).siblings("a").attr("href",href).addClass("disabled");
 }
  
});

$(".offer-act-desk button").on("click",function(e){
  e.preventDefault();
  $("#modal-offer").addClass("show");
});

$("#modal-offer .close").on("click",function(e){
  e.preventDefault();
  $("#modal-offer").removeClass("show");
});


var modal = document.getElementById("modal-offer");

window.onclick = function(event) {
  if (event.target == modal) {
    $("#modal-offer").removeClass("show");
  }
}

var url = window.location.href;

if(url.indexOf("contact_posted=true#offer-form") != -1)
{
  var newUrl = url.replace("?contact_posted=true#offer-form",'');
  history.pushState({}, null, newUrl);
  $("#modal-offer").addClass("show");
  $(".offer-form-field").hide();
  setTimeout(function(){
    $("#modal-offer").removeClass("show");
    $(".offer-form-field").show();
    $(".alert--success").hide();
    $(".alert--error").hide();
  },2000);
}

if(navigator.platform == 'iOS' || navigator.platform == 'iPhone')
{
  var offerLink = $(".offer-price").find("a").attr("data-url");
  offerLink = offerLink.replace("?","&");
  $(".offer-price").find("a").attr("data-url",offerLink);
  var chat = $(".chat-option.mobile-only").find("a").attr("href");
  chat = chat.replace("?","&");
  $(".chat-option.mobile-only").find("a").attr("href",chat);
}

      $(document).ready(function(){
  $(".nect--c").removeAttr("target");
})

$( ".boost-pfs-filter-collection-description .split-content" ).insertAfter( $( ".main-products-grid-container" ) );
$(".split-content").addClass("moved-content");